var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6152_3178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 11H3C2.447 11 2 10.552 2 10V2H0V0H3C3.553 0 4 0.448 4 1V9H12.246L13.674 4H12V2H15C15.917 2 16.048 2.973 15.962 3.275L13.962 10.275C13.839 10.704 13.446 11 13 11Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 16C4.10457 16 5 15.1046 5 14C5 12.8954 4.10457 12 3 12C1.89543 12 1 12.8954 1 14C1 15.1046 1.89543 16 3 16Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 16C14.1046 16 15 15.1046 15 14C15 12.8954 14.1046 12 13 12C11.8954 12 11 12.8954 11 14C11 15.1046 11.8954 16 13 16Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3V7H7V3H5L8 0L11 3H9Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6152_3178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSell);
export default __webpack_public_path__ + "static/media/sell.d583055b0496ed60b4c6d8c933672da6.svg";
export { ForwardRef as ReactComponent };